module.exports = __webpack_public_path__ + "img/carousel-1.ae347f6e.jpg";